<template>
  <div id="menu" class="z4 py2 caps flex justify-between" v-scroll-to="'#menu'">
    <div class="green ml2 py1">
      <mq-layout mq="sm">
        <span class="mobile-title" @click="showMobileMenu = !showMobileMenu"
          v-if="(this.$route.name === 'Channels' ||
          this.$route.name === 'Subchannel') &&
          this.$route.params.slug !== undefined">
            Channel → {{ this.$route.params.slug }}
            <span v-if="this.$route.params.subChannelSlug !== undefined"> → {{ this.$route.params.subChannelSlug.replace(new RegExp('-', 'g'), ' ') }}</span>
        </span>
        <span class="mobile-title"
          v-else-if="this.$route.name === 'Themes'"
          @click="showMobileMenu = !showMobileMenu">Themes
          <span v-if="this.$route.params.slug !== undefined"> → {{ this.$route.params.slug.replace(new RegExp('-', 'g'), ' ') }}</span>
        </span>
        <span v-else @click="showMobileMenu = !showMobileMenu">SOE.TV</span>
      </mq-layout>
      <mq-layout mq="md+">
        <router-link to="/" class="green">SOE.TV</router-link>
      </mq-layout>
    </div>
    <mq-layout mq="md+">
      <ul class="m0 mr2 py1">
        <li><router-link :to="menuLink('videos')" exact>All&thinsp;Videos</router-link></li>
        <li><router-link :to="menuLink('channels')">Channels</router-link></li>
        <li><router-link :to="menuLink('themes')">Themes</router-link></li>
        <li><router-link :to="menuLink('search')">Search</router-link></li>
        <li><router-link :to="menuLink('about')">About</router-link></li>
      </ul>
    </mq-layout>
    <mq-layout mq="sm">
      <ul class="m0 mr2 py1">
        <li @click="showMobileMenu = !showMobileMenu">
          <span v-if="!showMobileMenu">Menu</span>
          <span v-else>Close</span>
        </li>
      </ul>
      <div id="mobile-menu" v-if="showMobileMenu">
        <div class="pl2">
          <ul class="m0">
            <li @click="showMobileMenu = !showMobileMenu"><router-link :to="menuLink('videos')" exact>All&thinsp;Videos</router-link></li>
            <li><router-link :to="menuLink('channels')">Channels</router-link></li>
            <li>
              <ul v-if="isVisible('channels')" class="m0 ml3">
                <li class="channel" v-for="channel in channels" :key="channel.id">
                  <router-link :to='channelLink(channel)' v-if="channel.subchannels.length > 1">
                    {{ channel.name }}
                  </router-link>
                  <router-link v-else :to='channelLink(channel)'>
                    <span @click="showMobileMenu = !showMobileMenu">{{ channel.name }}</span>
                  </router-link>

                  <ul v-if="channel.subchannels.length > 1" class="subchannels ml3">
                    <li v-for="subchannel
                      in channel.subchannels"
                      :key="subchannel.id"
                      @click="showMobileMenu = !showMobileMenu">
                      <router-link class="block" :to='subChannelLink(channel, subchannel)'>
                        {{ subchannel.name }}
                      </router-link>
                    </li>
                  </ul>
                </li>
              </ul>
            </li>
            <li>
              <router-link :to="menuLink('themes')">Themes</router-link>
              <ul v-if="isVisible('themes')" class="m0 ml3">
                <li v-if="themes"
                  v-for="theme in themes"
                  :key="theme.id"
                  @click="showMobileMenu = !showMobileMenu">
                  <router-link :to='themeLink(theme)'>{{ theme.name }}</router-link>
                </li>
              </ul>
            </li>
            <li @click="showMobileMenu = !showMobileMenu"><router-link :to="menuLink('search')">Search</router-link></li>
            <li @click="showMobileMenu = !showMobileMenu"><router-link :to="menuLink('about')">About</router-link></li>
          </ul>
        </div>
      </div>
    </mq-layout>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'

export default {

  name: 'MainMenu',

  data () {
    return {
      showMobileMenu: false
    }
  },

  computed: {
    ...mapState([
      'channels',
      'themes'
    ])
  },

  methods: {
    ...mapActions([
      'toggleVideosSidebar'
    ]),
    menuLink: function (path) {
      if (this.$route.hash) {
        return '/' + path + this.$route.hash
      } else if (this.$route.name === 'Videos' && this.$route.params.slug) {
        return `/${path}#${this.$route.params.slug}`
      } else {
        return `/${path}`
      }
    },
    channelLink: function (channel) {
      return '/channels/' + channel.slug + this.$route.hash
    },
    subChannelLink: function (channel, subchannel) {
      return '/channels/' + channel.slug + '/' + subchannel.slug + this.$route.hash
    },
    themeLink: function (theme) {
      return '/themes/' + theme.slug + this.$route.hash
    },
    isVisible: function (name) {
      if (name === 'channels') {
        return (this.$route.name === 'Channels' || this.$route.fullPath.includes('/channels'))
      } else if (name === 'themes') {
        return (this.$route.name === 'Themes' || this.$route.fullPath.includes('/themes'))
      } else {
        return false
      }
    }
  }
}
</script>

<style lang="css" scoped>
#menu {
  background: var(--color-black);
  position: sticky;
  top: 0;
  font-size: var(--font-size-large);
  letter-spacing: 1px;

  ul {
    li {
      display: inline-block;
      list-style: none;
    }
  }

  a.router-link-active {
    color: var(--color-green);
  }
}

.mobile-title {
  max-width: 80vw;
  overflow: hidden;
  display: block;
  text-overflow: ellipsis;
  white-space: nowrap;
}

#mobile-menu {
  position: fixed;
  top: 64px;
  left: 0;
  right: 0;
  bottom: 0;
  background: var(--color-black);

  ul {
    li {
      display: block;
      line-height: 3;
    }
  }

  .channel {
    .subchannels {
      display: none;
    }

    a.router-link-active+.subchannels {
      display: block;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/MainMenu.vue